import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Cookies = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-24 pb-16 container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Cookie Policy</h1>
        <div className="prose prose-lg text-muted-foreground space-y-6">
          <p><strong>Last updated:</strong> February 2026</p>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8">What Are Cookies?</h2>
            <p>
              Cookies are small text files placed on your device when you visit a website. They help
              the website function properly and securely.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8">Cookies We Use</h2>

            <h3 className="text-xl font-semibold text-foreground mt-4">Strictly Necessary Cookies</h3>
            <p>
              This website uses essential cookies only. These cookies are required for the website
              to operate and cannot be switched off.
            </p>
            <p>They are used for:</p>
            <ul className="list-disc pl-6">
              <li>Website security</li>
              <li>Network management</li>
              <li>Saving your cookie preferences</li>
              <li>Ensuring the website functions correctly</li>
            </ul>
            <p>We do not use analytics, marketing, or tracking cookies.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8">Managing Cookies</h2>
            <p>
              Because these cookies are essential to the operation of the website, they cannot be
              disabled through the website.
            </p>
            <p>However, you can control cookies through your browser settings if you wish.</p>
            <p>
              More information:{" "}
              <a
                href="https://www.allaboutcookies.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                www.allaboutcookies.org
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8">Contact</h2>
            <p>If you have questions about our use of cookies, please contact:</p>
            <p>
              Coblynau IT Solutions<br />
              Email:{" "}
              <a href="mailto:info@coblynausolutions.co.uk" className="text-primary hover:underline">
                info@coblynausolutions.co.uk
              </a>
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Cookies;
